import React, { useState } from 'react';

const ACCENT = '#4A7C59';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/production/auth?action=forgot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const d = await res.json();
        setError(d.error || 'Something went wrong. Please try again.');
        return;
      }
      setSuccess(true);
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-shell min-h-screen flex items-center justify-center bg-[#FAFAF8]">
      <div className="w-full max-w-sm p-8">
        {/* Back to login */}
        <a
          href="/production/login"
          className="inline-flex items-center gap-1.5 text-sm text-[#6B6B6B] hover:text-[#1A1A1A] mb-8"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back to login
        </a>

        <div className="mb-8">
          <div
            className="inline-flex items-center justify-center w-10 h-10 rounded-lg mb-4"
            style={{ backgroundColor: ACCENT }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-[#1A1A1A]">Forgot password?</h1>
          <p className="text-sm text-[#6B6B6B] mt-1">
            Enter your email and we'll send you a reset link.
          </p>
        </div>

        {success ? (
          <div className="p-4 rounded-lg" style={{ background: `${ACCENT}1A`, border: `1px solid ${ACCENT}33` }}>
            <p className="text-sm font-medium" style={{ color: '#2D5C3F' }}>Check your email</p>
            <p className="text-sm mt-1" style={{ color: '#2D5C3F' }}>
              If an account exists for <strong>{email}</strong>, we've sent a password reset link. Check your inbox.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                {error}
              </div>
            )}

            <div className="mb-6">
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email address"
                autoFocus
                required
                className="w-full px-4 py-3 border border-[#E8E6E2] rounded-lg bg-white text-[#1A1A1A] placeholder-[#A3A3A3] focus:outline-none"
                onFocus={e => (e.target.style.boxShadow = `0 0 0 2px ${ACCENT}33`)}
                onBlur={e => (e.target.style.boxShadow = '')}
              />
            </div>

            <button
              type="submit"
              disabled={loading || !email}
              className="w-full py-3 text-white rounded-lg font-medium transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
              style={{ backgroundColor: ACCENT }}
            >
              {loading ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
